export default __webpack_public_path__ + "static/media/AudienceGrey.473cad41.svg";